"use client";

// src/group/group-label-context.tsx
import { createContext } from "react";
var GroupLabelContext = createContext(void 0);

export {
  GroupLabelContext
};
